import React from 'react';
import { get } from 'lodash';

function ExternalAuthProviders(props) {
  const { providers, isBasicProvider } = props;

  return providers.length ? (
    <div className="external-auth-providers">
      {
        isBasicProvider && (
          <strong className="label">OR</strong>
        )
      }
      <div className="items">
        {
          providers.map((provider) => {
            const providerIcon = get(provider, 'loginBtn.icon', null);

            return (
              <a
                key={provider.type}
                href={get(provider, 'loginUrl', '#')}
                className="item"
              >
                {providerIcon ? (
                  <img
                    src={providerIcon}
                    width="20"
                    alt="Icon"
                  />
                ) : null}
                {get(provider, 'loginBtn.text', 'Login')}
              </a>
            );
          })
        }
      </div>
    </div>
  ) : null;
}

export default ExternalAuthProviders;
